import classNames from 'classnames';
import React from 'react';
import { Button, Image } from 'react-bootstrap';

export interface IActionButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
    iconclass?: string,
    text: string,
    disabled?: boolean,
    src?: string | undefined,
}

export const ActionButton = (props: IActionButtonProps) => {
    const { className } = props;
    return (<Button {...props} className={classNames("action-button", className)} variant="light" >
        <div className="d-flex align-items-center">
            {props.iconclass && <span className={props.iconclass} />}
            {props.src && <Image src={props.src} className="" />}
            <div style={{ whiteSpace: "nowrap", paddingTop: ".2rem", paddingLeft: ".5rem", paddingRight: ".5rem" }}>{props.text}</div>
        </div>
    </Button>
    )
}
